import { Checkbox, Dropdown } from 'antd'
import { ItemType } from 'antd/lib/menu/hooks/useItems'
import Down from 'helper/Icons/DownIcon'
import { useState } from 'react';

const SpaceTypeFilters = ({ filters, setFilters }: { filters: any, setFilters: any }) => {

	const [selectedTypes, setSelectedTypes] = useState([]);

	const SpaceTypeOptions = [
		{
			label: 'Event',
			value: 'event',
		},
		{
			label: 'League',
			value: 'league',
		},
		{
			label: 'Community',
			value: 'community',
		},
		{
			label: 'External',
			value: 'external',
		},
	]

	const StatusFilters: ItemType[] = [
		{
			key: 'spaceType',
			label: (
				<>
					<Checkbox.Group
						options={SpaceTypeOptions}
						className="category-checkbox"
						value={selectedTypes}
						onChange={setSelectedTypes}

					/>
					<div className="flex justify-between mx-15px mt-10px">
						<button
							className="clr-btn"
							onClick={() => {
								setSelectedTypes([]);

								setFilters(prev => {
									const { spaceType, ...rest } = prev;
									return rest;
								});
							}}
						>
							Clear
						</button>
						<button
							className="aply-btn"
							onClick={() => {
								setFilters(prev => ({
									...prev,
									spaceType: selectedTypes,
								}));
							}}
						>
							Apply
						</button>
					</div>
				</>
			),
		},
	]


	return (
		<>
			<Dropdown
				menu={{ items: StatusFilters }}
				placement="bottomLeft"
				overlayStyle={{ width: 200 }}
				overlayClassName="custom-dropdown-overlay"
			>
				<button
					className="filter-btn"
					style={{ cursor: 'pointer', marginBottom: '5px' }}
				>
					Space Type <Down />
				</button>
			</Dropdown>
		</>
	)
}

export default SpaceTypeFilters